export default __webpack_public_path__ + "static/media/img_7.50d2b3c7.JPG";